"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviderMappingQuery = exports.getProviderMappingConfigsQuery = exports.useSaveWorkflowConfigQuery = exports.getWorkflowConfigsQuery = exports.getWorkflowConfigQuery = exports.getServerVerionQuery = exports.supportUrlQuery = exports.supportKeys = void 0;
const react_query_1 = require("@tanstack/react-query");
const codingRepository_1 = __importDefault(require("../repositories/codingRepository"));
const configRepository_1 = require("../repositories/configRepository");
const supportRepository_1 = require("../repositories/supportRepository");
const query_keys_1 = require("./query-keys");
exports.supportKeys = {
    getSupportUrl: 'getSupportUrl',
    getServerVersion: 'getServerVersion',
    getWorkflowConfig: 'getWorkflowConfig',
    getWorkflowConfigs: 'getWorkflowConfigs',
    getProviderMappingConfigs: 'getProviderMappingConfigs',
};
exports.supportUrlQuery = (0, react_query_1.queryOptions)({
    queryKey: [exports.supportKeys.getSupportUrl],
    queryFn: supportRepository_1.SupportRepository.getSupportUrl,
});
const getServerVerionQuery = () => ({
    queryKey: [exports.supportKeys.getServerVersion],
    queryFn: configRepository_1.ConfigRepository.getServerVersion,
});
exports.getServerVerionQuery = getServerVerionQuery;
const getWorkflowConfigQuery = ({ companyId }) => ({
    queryKey: [exports.supportKeys.getWorkflowConfig, companyId],
    queryFn: () => supportRepository_1.SupportRepository.getWorkflowConfig({ companyId }),
    enabled: !!companyId,
});
exports.getWorkflowConfigQuery = getWorkflowConfigQuery;
const getWorkflowConfigsQuery = () => ({
    queryKey: [exports.supportKeys.getWorkflowConfigs],
    queryFn: supportRepository_1.SupportRepository.getWorkflowConfigs,
});
exports.getWorkflowConfigsQuery = getWorkflowConfigsQuery;
const useSaveWorkflowConfigQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: supportRepository_1.SupportRepository.setWorkflowConfig,
    });
};
exports.useSaveWorkflowConfigQuery = useSaveWorkflowConfigQuery;
const getProviderMappingConfigsQuery = () => ({
    queryKey: [exports.supportKeys.getProviderMappingConfigs],
    queryFn: configRepository_1.ConfigRepository.getProviderMappingConfigs,
});
exports.getProviderMappingConfigsQuery = getProviderMappingConfigsQuery;
const getProviderMappingQuery = () => ({
    queryKey: [query_keys_1.codingKeys.getProviderMapping],
    queryFn: codingRepository_1.default.getProviderMapping,
});
exports.getProviderMappingQuery = getProviderMappingQuery;
